import { SchemaClient } from "../../../common/GraphqlClient";
import { EMPTY_VALUE, FieldValues, Schema } from "../../../Schema";
import { getEntry, getAndProcessEntry } from "../../common/external-sources/Entry";

/**
 * Equipment getters. The selection set is derived from the passed equipment
 * schema (see `prepareEquipmentSchema`); see `Entry.ts` for the mechanics.
 */

/** Fetches an equipment entry by id and returns the raw GraphQL record. */
export const getEquipment = async (
  client: SchemaClient,
  schema: Schema,
  id: string
): Promise<FieldValues | typeof EMPTY_VALUE> => {
  return await getEntry(client, schema, id);
};

/** Fetches an equipment entry by id and maps it into form values (`FROM_GRAPHQL`). */
export const getAndProcessEquipment = async (
  client: SchemaClient,
  schema: Schema,
  id: string
): Promise<FieldValues> => {
  return await getAndProcessEntry(client, schema, id);
};
